const React = require('react')
const PropTypes = require('prop-types')
const SignupLink = require('./signup_link')
const NavLink = require('./nav_link')
const log = require('log').create('nav', 'anonymous links') // eslint-disable-line

function AnonymousLinks(props) {
    const { render_signup, render_login, signup_button_props } = props
    if (render_signup || render_login) {
        return (
            <ul className="userlinks">
                <SignupLink condition={render_signup} {...signup_button_props} />
                <NavLink
                    href="/features"
                    className="features not-mobile"
                    data-metric-channel="metrics_nav"
                    data-metric-event="clicked:features"
                    >
                    Features
                </NavLink>
                <NavLink
                    href="/pricing"
                    className="pricing not-mobile"
                    data-metric-channel="metrics_nav"
                    data-metric-event="clicked:pricing"
                    >
                    Pricing
                </NavLink>
                <NavLink
                    condition={render_login}
                    href="/login"
                    data-metric-channel="metrics_nav"
                    data-metric-event="clicked:pricing"
                    >
                    Log In
                </NavLink>
            </ul>
        )
    }
    return null
}
AnonymousLinks.propTypes = {
    render_signup: PropTypes.bool,
    render_login: PropTypes.bool,
    signup_button_props: PropTypes.object,
}

module.exports = AnonymousLinks
